import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider, ISearchProviderField, ISearchRequestSubset, ISearchSort,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {SalesAreaSearch} from "./SalesAreaSearch";
import * as _ from "lodash";



class CustomerSearchByMDSetProvider
    implements ISearchProvider {
    _wbMDSetId: number = undefined
    _vUI_Customer_Search_Fields:any =
        {
            WB_MDSET_ID: {
                type: SearchProviderFieldType.number,
                renderOptions: { columnName: 'Master Date Set WB Id',  columnResourceName: 'colMDSetWBId',      alignment: HorizAlignment.Center},
                domainOptions: { }
            },
            WB_CUST_ID: {
                type: SearchProviderFieldType.number,
                renderOptions: { columnName: 'Customer WB Id',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center},
                domainOptions: { }
            },
            CUSTOMER_ID: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},
                domainOptions: { maxLength: 50}
            },
            CUSTOMER_NAME: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},
                domainOptions: { maxLength: 256}
            },
            CUSTOMER_TYPE: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},
                domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
            },
            WB_SALESAREA_ID: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Sales Area WB Id',  columnResourceName: 'colCustSARWBId', alignment: HorizAlignment.Center},
                domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}
            },
            ALL_SALES_AREAS: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colCustSalesArea',      alignment: HorizAlignment.Left},
                domainOptions: { maxLength: 256}
            },
            CUSTOMER_TYPES: {
                type: SearchProviderFieldType.string,
                renderOptions: { columnName: 'Customer Type',   columnResourceName: 'colCustTypes',      alignment: HorizAlignment.Left},
                domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}
            },
            CREATED_DTTS: {
                type: SearchProviderFieldType.sapdate,
                renderOptions: {
                    columnName: 'Created Date',
                    columnResourceName: 'colCreateDt',
                    alignment: HorizAlignment.Center,
                    dateFormat: "MM-dd-yy"
                },
                domainOptions: {}
            },
            MODIFIED_DTTS: {
                type: SearchProviderFieldType.sapdate,
                renderOptions: {
                    columnName: 'Modified Date',
                    columnResourceName: 'colModifiedDt',
                    alignment: HorizAlignment.Center,
                    dateFormat: "MM-dd-yy"
                },
                domainOptions: {}
            }
        }

    constructor(wbMDSetId?: number) {
        this._wbMDSetId = wbMDSetId
        this._vUI_Customer_Search_Fields.WB_SALESAREA_ID.domainOptions.searchCondition = {WB_MDSET_ID: this._wbMDSetId}

    }
        keyFields= {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'}


        searchProviderFields= this. _vUI_Customer_Search_Fields

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {
                if (this._wbMDSetId > 0)
                    searchOptions.where.WB_MDSET_ID = this._wbMDSetId


                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Customer_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        let returnVals: any[] = _.uniqBy(res, aRes => aRes.WB_CUST_ID)
                        resolve(returnVals)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

        distinctValues(fieldName: string): Promise<string[] | number[]> {
            return new Promise<string[] | number[]>((resolve, error) => {
                let query: { where: { [id: string]: any } } = {where: {}}
                if (this._wbMDSetId > 0)
                    query.where.WB_MDSET_ID = this._wbMDSetId


                let findRequest = SearchUtils.makeSearchRequest(query,
                    'vUI_Customer_Search',
                    this.searchProviderFields,
                    [fieldName])

                let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    findRequest.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
                }


                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            })
        }

    }


class CustomerSearchByMDSetProfile
    implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined

    profileId= "default"
    profileName= "Search by Id, Name"
    renderOptions= { ui5ResourceId: "CustomerSearchProfileByName" }

    profileFilter= [
        {profileFilterName: 'Customer Id',      searchProviderFieldId: 'CUSTOMER_ID',       renderOptions: { }},
        {profileFilterName: 'Customer Name',    searchProviderFieldId: 'CUSTOMER_NAME',     renderOptions: { }},
        {profileFilterName: 'Customer Type',    searchProviderFieldId: 'CUSTOMER_TYPE',    renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Sales Area',       searchProviderFieldId: 'WB_SALESAREA_ID',   bMultiSelect: true, renderOptions: { }},
    ]  // ISearchFields
    profileDisplayFields= [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPES','ALL_SALES_AREAS', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ] //string[];   // Search Provider Field Name (Use to Generate Grid Columns)



    profileTreeIdDefault="default"
    profileTrees= [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ]
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault=""   //string;
    profileSorts:ISearchSort []=[] //ISearchSort[];

    constructor(wbMDSetId: number) {
        this.aSearchProvider = new CustomerSearchByMDSetProvider(wbMDSetId)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }
}

export class CustomerSearchByMDSet
    implements ISearch {
    constructor(wbMDSetId?: number) {
        this.searchProfiles = [new CustomerSearchByMDSetProfile(wbMDSetId)]
    }

    searchName= "Find Customer"
    renderOptions={ ui5ResourceId: "CustomerSearchByMDSet"}
    searchProfileIdDefault= "default"
    searchProfiles: ISearchProfile[] = []

}


